import landingPageStyles from "../css/auth/auth-landing-screen.module.css";
import sharePageStyles from '../css/share/loggedout-sharepage.module.css'
import styles from '../css/share/loggedout-sharepage.module.css';
import background from "../../images/signup-page-background.svg";
import logo from "../../images/logo_red.svg";
import { useHistory } from 'react-router-dom';
import { Link, useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { useContext } from "react";
import { ShareLinkContext } from "./ShareLinkContext";


const LoggedOutSharePage = ({ children }) => {
    const history = useHistory();
    const { isContentReady, sharerName } = useContext(ShareLinkContext);

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const queryPairs = Array.from(searchParams.entries());
    const [entryType, shareCode] = queryPairs.length > 0 ? queryPairs[0] : [null, null];
    let bgStyle = {};
    if (entryType === 'story') {
        bgStyle = { backgroundColor: 'black' };
    }

    const getNormiliIntro = () => {
        let jsx = <></>;
        if (entryType === 'flow') {
            jsx = <>
                <h4 className={sharePageStyles.ctaHeading}>Feel it. Learn from it.</h4>
                <p className={sharePageStyles.ctaSubheading}>
                    That's what {sharerName} is doing with Normili. 
                    Because emotions aren't noise, they're valuable signals. 
                    And we turn them into insights 💎 about what lights you up and wears you down.
                </p>
                <p className={sharePageStyles.ctaSubheading} style={{fontWeight: 550}}>
                    Could that kind of clarity help you too?
                </p>
            </>
        }
        else  {
            jsx = <>
                <h4 className={sharePageStyles.ctaHeading}>Burnout won't catch {sharerName} off guard</h4>
                <p className={sharePageStyles.ctaSubheading}>
                    Because every Friday they get to see which way their mental health is trending, and course correct early.
                </p>
                <p className={sharePageStyles.ctaSubheading} style={{fontWeight: 550}}>
                    Could that kind of clarity help you too?
                </p>
            </>
        }

        return jsx;
    }

    return (
        <div className={landingPageStyles.page} style={{ width: '100%', ...bgStyle }}>
            <header className={landingPageStyles.header}>
                <Link to="/" className={landingPageStyles.brandContainer}>
                    <img src={logo} className={landingPageStyles.logo} alt="Normili Logo"></img>
                    <div className={landingPageStyles.brandTitle}>Normili</div>
                </Link>
                <button className={styles.signInButton} onClick={() => history.push('/signin')}>
                    Sign In
                </button>
            </header>
            <div className={landingPageStyles.formContainer}>
                {children}
            </div>
            {isContentReady &&
                <div className={sharePageStyles.ctaSection}>
                    <div className={sharePageStyles.signUpCard}>
                        {getNormiliIntro()}
                        <button className={sharePageStyles.signUpButton} onClick={() => history.push("/signup")}>
                            Try Normili
                        </button>
                    </div>
                    <img
                        src={background}
                        className={sharePageStyles.mountainImage}
                        alt="Person walking towards balance and away from burnout"
                    />
                </div>
            }
        </div>
    );
};

export default LoggedOutSharePage;